import React from 'react';
import { Shield, X } from 'lucide-react';

const SystemUpgradeModal = ({ isOpen,onClose,data }) => {

if (!isOpen) return null;

const handleGoToStatus = () => {
window.location.href = '/system-status';
onClose();
};

return (
<div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4 backdrop-blur-sm">
<div className="bg-white rounded-2xl lg:max-w-lg p-6 shadow-2xl">
<div className="flex items-start justify-between mb-4">
<h3 className="text-xl font-bold text-slate-900">
Temporary Service Disruption
</h3>
<button
onClick={onClose}
className="p-1 hover:bg-slate-100 rounded-lg"
>
<X size={20} />
</button>
</div>

<p className="text-slate-700 mb-3">
We sincerely apologize for the inconvenience. We are currently
performing a major server upgrade to improve the quality, reliability,
and performance of our services.
</p>

<p className="text-slate-700 mb-3">
During this period, some critical features may not function as
expected. This process may take up to <strong>one week</strong>.
</p>

<p className="text-slate-700 mb-4">
To compensate, additional time will be automatically added to your
subscription once the upgrade is complete.
</p>

<div className="flex items-center gap-2 text-sm text-slate-500 mb-6">
<Shield size={16} />
<span>Your data remains safe and secure</span>
</div>

<div className="flex gap-3">
<button
onClick={onClose}
className="flex-1 px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold rounded-lg"
>
Close
</button>

<button
 onClick={handleGoToStatus}
className="flex-1 px-4 py-3 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-lg"
>
Check update status
</button>
</div>
</div>
</div>
);
};

export default SystemUpgradeModal;
